module.exports = __webpack_public_path__ + "img/header_code4.ff3aedc9.jpg";